module.exports = ".app-toolbar {\n  z-index: 10;\n  position: absolute; }\n\n.flex-spacer {\n  -webkit-box-flex: 1;\n      -ms-flex-positive: 1;\n          flex-grow: 1; }\n\n.toolbar-form {\n  min-width: 150px;\n  max-width: 500px;\n  width: 100%; }\n\n.toolbar-full-width {\n  width: 100%; }\n\n.search-bar {\n  font-family: Roboto, \"Helvetica Neue\", sans-serif;\n  font-size: 14px;\n  font-weight: 500; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/toolbar/toolbar.component.scss
// module id = ./src/app/shared/components/toolbar/toolbar.component.scss
// module chunks = main